import styled, { withTheme } from 'styled-components'
import IconArrowRight from '../../../vectors/IconArrowRight'

const ArrowRight = styled(IconArrowRight)`
  width: 20px;
  path {
    transition: fill 0.5s ${(props) => props.theme.ease.ease_out_expo};
    fill: ${(props) => props.theme.colors.blue};
  }
`
export default withTheme(ArrowRight)
